import {Dispatch, FC, SetStateAction, useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {KTSVG} from '../../../../../../../../_metronic/helpers'
import {useForm} from 'react-hook-form'
import {yupResolver} from '@hookform/resolvers/yup'
import * as Yup from 'yup'
import {InputTextArea} from '../../../../../../components/UI/Input'
import {useCentralServices} from '../../../../hooks/useCentralServices'
import {SelectOption} from '../../../../../../models/utility.model'
import {Select} from '../../../../../../components/UI/Select'
import {downloadPDFCheckInOutService} from '../../../../services/booking.service'
import {getSnackBar, getSnackBarToast} from '../../../../../../util/snackBar'
import moment from 'moment'

interface Props {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
  itemToEdit: any
  getBookings: () => void
}

const ModalRePrintCO: FC<Props> = ({show, setShow, itemToEdit, getBookings}) => {
  const {getMasterTable} = useCentralServices()
  const [showText, setShowText] = useState(false)
  const [reasons, setReasons] = useState<SelectOption[]>([])

  const isPrintable = itemToEdit.ImpresionCheckOut && itemToEdit.ImpresionCheckOut > 0

  const handleClose = () => {
    setShow(false)
  }

  const rePrintSchema = Yup.object().shape({
    MotivoReImpresionId: Yup.string().required('Motivo es requerido'),
  })

  const {
    register,
    reset,
    handleSubmit,
    control,
    setValue,
    setError,
    formState: {errors},
  } = useForm({
    resolver: yupResolver(rePrintSchema),
  })

  const onSubmit = async (datos: any) => {
    try {
      let dto = {
        reservaCamaId: itemToEdit.ReservaCamaId,
        tipo: 'OUT',
        MotivoReimpresionId: datos?.MotivoReImpresionId,
        Otros: datos?.Otros,
      }
      const response = await downloadPDFCheckInOutService(dto)
      const blob = new Blob([response.data], {
        type: 'application/pdf',
      })
      // Crea un enlace temporal y simula un clic para descargar el archivo
      moment().format('DD/MM/YY HH:mm').toString()
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `CheckOut-${moment().format('DD/MM/YY HH:mm').toString()}.pdf` // Ajusta el nombre del archivo según tus necesidades
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      getSnackBarToast('Se descargó el documento con éxito', 'success')
      reset()
    } catch (error) {
      console.log(error)
    }
  }

  const getReasonsRePrint = async () => {
    const data = await getMasterTable('MotivoReimpresionReserva', true)
    setReasons(data)
  }

  const handleReasonsChange = (val: any) => {
    let value = val ? val.value : ''
    setValue('MotivoReImpresionId', value)
    if (value === 'vsjVgdF@bBw=') {
      setShowText(true)
    } else {
      setValue('Otros', '')
      setShowText(false)
    }
    setError('MotivoReImpresionId', {})
  }

  useEffect(() => {
    getReasonsRePrint()
  }, [])

  return (
    <Modal
      className='modal fade'
      show={show}
      dialogClassName='modal-md'
      aria-hidden='true'
      onHide={handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h5 className='modal-title'>ReImprimir checkout</h5>
          <div className='btn btn-icon btn-sm btn-active-light-primary ms-2' onClick={handleClose}>
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
          <form>
            {isPrintable ? (
              <div className='p-6'>
                <div className='d-flex'>
                  <div className='col-sm-6'>
                    <label>Motivo:</label>
                    <Select
                      control={control}
                      name='MotivoReImpresionId'
                      data={reasons}
                      errors={errors}
                      onChangeValue={handleReasonsChange}
                    />
                  </div>
                  {showText ? (
                    <div className='col-sm-6'>
                      <label>Otros:</label>
                      <InputTextArea
                        name='Otros'
                        textPlaceholder='Motivo por el cual desea re imprimir?'
                        register={register}
                        errors={errors}
                      />
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            ) : (
              <div>El checkout aún no ha sido impreso</div>
            )}

            {/* <pre>{JSON.stringify(watch(), null, 2)}</pre> */}
            <div className='d-flex justify-content-center mb-3'>
              <button type='button' className='btn btn-light-primary me-5' onClick={handleClose}>
                Cancelar
              </button>
              {isPrintable ? (
                <button type='button' className='btn btn-primary' onClick={handleSubmit(onSubmit)}>
                  Imprimir
                </button>
              ) : (
                <></>
              )}
            </div>
          </form>
        </div>
      </div>
    </Modal>
  )
}

export {ModalRePrintCO}
